import { Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { CreateProtocolPanel } from '../../../dialogs/CreateProtocolPanel';
import { useCreateStructuredProtocol } from '../../../../hooks/entity/useCreateStructuredProtocol';
import type { CreateBodyProps } from './createBodyProps';
import { destinationParent } from '../destination/createDestination';

/**
 * New protocol, in the chosen place. The source document of an import is
 * filed beside the protocol it becomes, so both land in the destination.
 */
export function ProtocolBody({
  destination,
  surface,
  onDone,
  onDestinationProblem,
  onBusyChange,
}: CreateBodyProps) {
  const { startFromFile, startBlank, isBusy } = useCreateStructuredProtocol({
    surface,
    parent: destinationParent(destination),
    onCreated: onDone,
    onDestinationProblem,
  });

  useEffect(() => {
    onBusyChange(isBusy);
  }, [isBusy, onBusyChange]);

  return (
    <Flex direction="column" flex={1} minH={0}>
      <CreateProtocolPanel
        onFileChosen={(file) => void startFromFile(file)}
        onStartBlank={() => void startBlank()}
        isBusy={isBusy}
      />
    </Flex>
  );
}
